define(["require", "exports", "tslib", "vue", "clipboard"], function (require, exports, tslib_1, vue_1, clipboard_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.handleClipboard = exports.clipboardError = exports.clipboardSuccess = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    clipboard_1 = (0, tslib_1.__importDefault)(clipboard_1);
    var clipboardSuccess = function () {
        return vue_1.default.prototype.$message({
            message: 'Copy successfully',
            type: 'success',
            duration: 1500
        });
    };
    exports.clipboardSuccess = clipboardSuccess;
    var clipboardError = function () {
        return vue_1.default.prototype.$message({
            message: 'Copy failed',
            type: 'error'
        });
    };
    exports.clipboardError = clipboardError;
    var handleClipboard = function (text, event) {
        var clipboard = new clipboard_1.default(event.target, {
            text: function () { return text; }
        });
        clipboard.on('success', function () {
            (0, exports.clipboardSuccess)();
            clipboard.destroy();
        });
        clipboard.on('error', function () {
            (0, exports.clipboardError)();
            clipboard.destroy();
        });
        clipboard.onClick(event);
    };
    exports.handleClipboard = handleClipboard;
});
//# sourceMappingURL=UtilsClipboard.js.map